module.exports = "https://stanwinstonschool.com/school-new-mobile.75b6918d76434a5b455816b87edb7ba9.jpg";